import { render, staticRenderFns } from "./tabManagement.vue?vue&type=template&id=b97e9582&scoped=true&"
import script from "./tabManagement.vue?vue&type=script&lang=js&"
export * from "./tabManagement.vue?vue&type=script&lang=js&"
import style0 from "./tabManagement.vue?vue&type=style&index=0&id=b97e9582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97e9582",
  null
  
)

component.options.__file = "tabManagement.vue"
export default component.exports